import api from './api';

class AuthService {
  constructor() {
    this.profileCache = null;
    this.profilePromise = null;
  }

  async register(phone, password, name) {
    const response = await api.post('/auth/register', { phone, password, name });
    if (response.data.accessToken) {
      localStorage.setItem('token', response.data.accessToken);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  }

  async login(phone, password) {
    const response = await api.post('/auth/login', { phone, password });
    if (response.data.accessToken) {
      localStorage.setItem('token', response.data.accessToken);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  }

  async getProfile({ forceRefresh = false } = {}) {
    if (this.profileCache && !forceRefresh) {
      return this.profileCache;
    }
    if (this.profilePromise && !forceRefresh) {
      return this.profilePromise;
    }
    this.profilePromise = api
      .get('/auth/profile')
      .then((response) => {
        localStorage.setItem('user', JSON.stringify(response.data));
        this.profileCache = response.data;
        return response.data;
      })
      .finally(() => {
        this.profilePromise = null;
      });
    return this.profilePromise;
  }

  async updateProfile(data) {
    const response = await api.put('/auth/profile', data);
    localStorage.setItem('user', JSON.stringify(response.data));
    return response.data;
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    this.profileCache = null;
    this.profilePromise = null;
  }

  getStoredUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  isAuthenticated() {
    return !!localStorage.getItem('token');
  }
}

export const authService = new AuthService();
